module.exports = __webpack_public_path__ + "img/company-two.f5ef379a.jpg";